// Module
var code = "<div class=\"row\"> <div class=\"value\"></div> <div class=\"unit\"></div> </div> ";
// Exports
export default code;